import { Carousel } from "@mantine/carousel";
import Autoplay from "embla-carousel-autoplay";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { theme } from "#app/theme/v1";
import { AutoLoader } from "#modules/similarPart/view/AutoLoader";
import { Illustration, IllustrationName } from "#shared/icons/Illustration";
import { Flex } from "#shared/view/components/Flex";
import { Paper } from "#shared/view/components/Paper";
import { Space } from "#shared/view/components/Space";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

const shapes: IllustrationName[] = ["shape-1", "shape-2", "shape-3"];
const allShapes = [...shapes, ...shapes, ...shapes, ...shapes];

const CURRENT_SHAPE_SIZE = 150;

export const AiLoader = () => {
  const { t } = useTranslation();
  const autoplay = useRef(Autoplay({ delay: 2000 }));
  const [currentSlide, setCurrentSlide] = useState(1);

  return (
    <Flex h="calc(93vh" justify="center" align="center">
      <Paper
        shadow="lg"
        p="md"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background:
            "var(--Blue-gradient, linear-gradient(103deg, #2955E2 1.95%, #0B267B 91.53%))",
        }}
        w="90%"
        h="90%"
      >
        <Carousel
          slideSize="33.333333%"
          slideGap="md"
          emblaOptions={{ loop: true }}
          withControls={false}
          initialSlide={1}
          plugins={[autoplay.current]}
          onSlideChange={setCurrentSlide}
          style={{ width: 500 }}
        >
          {allShapes.map((name, index) => (
            <Carousel.Slide key={index}>
              <Stack justify="center" align="center" h={CURRENT_SHAPE_SIZE}>
                <Illustration
                  name={name}
                  style={{
                    transform: index === currentSlide ? "scale(2)" : "",
                    transition: "transform 0.5s",
                  }}
                />
              </Stack>
            </Carousel.Slide>
          ))}
        </Carousel>

        <Space h="md" />

        <Text c={theme.white}>{t("similarPart.aiLoader.title")}</Text>
        <Text c={theme.white} size={"xs"}>
          {t("similarPart.aiLoader.subTitle")}
        </Text>

        <AutoLoader />
      </Paper>
    </Flex>
  );
};
